module.exports = __webpack_public_path__ + "img/banner5.da60f601.png";